<template>
    <div class="h-[100px] flex items-end">
        <div class="w-full">
            <div
                class="w-full transition-all ease-in-out duration-200"
                :style="resultPosition"
            >
                <div class="w-[48px] relative h-[50px]">
                    <img
                        class="absolute z-[2] w-[44px] h-[50px] left-0 pointer-events-none"
                        :src="DicePointerImg"
                    />
                    <svg
                        class="z-[0] top-0"
                        :class="isGreen ? 'text-[#24e34d]' : 'text-[#F82E59FF]'"
                        width="44"
                        height="50"
                        viewBox="0 0 44 50"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13.1322 38.5246H31.1322L22.803 49.2575C22.5266 49.6136 21.7378 49.6136 21.4614 49.2575L13.1322 38.5246Z"
                        ></path>
                        <path
                            d="M5.93955 8.49031L17.7424 4.14187C20.5799 3.09649 23.693 3.07297 26.5459 4.07535L37.8961 8.06324C39.5282 8.6367 40.6068 10.1944 40.5692 11.924L40.251 26.5595C40.177 29.9651 38.3745 33.0988 35.4679 34.875L26.3632 40.439C23.7713 42.0229 20.5059 42.0023 17.9342 40.3858L8.94918 34.7381C6.2373 33.0335 4.50611 30.1329 4.29304 26.9369L3.33123 12.5098C3.21323 10.7398 4.27503 9.10355 5.93955 8.49031Z"
                        ></path>
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M25.7172 6.434C23.4129 5.62439 20.8985 5.64339 18.6067 6.48773L6.80381 10.8362C6.17962 11.0661 5.78144 11.6797 5.82569 12.3435L6.78751 26.7706C6.94731 29.1676 8.2457 31.3431 10.2796 32.6215L19.2646 38.2692C21.0327 39.3806 23.2776 39.3948 25.0596 38.3058L34.1643 32.7418C36.3442 31.4096 37.6961 29.0594 37.7516 26.5052L38.0698 11.8697C38.0839 11.2211 37.6794 10.6369 37.0674 10.4219L25.7172 6.434ZM16.8782 1.79601C20.2613 0.549603 23.9731 0.521558 27.3747 1.7167L38.7248 5.70459C41.3771 6.63647 43.1297 9.16779 43.0686 11.9783L42.7504 26.6139C42.6579 30.8708 40.4048 34.7879 36.7715 37.0082L27.6668 42.5722C24.2649 44.6511 19.9792 44.6241 16.6038 42.5024L7.61875 36.8547C4.2289 34.7239 2.06491 31.0983 1.79858 27.1032L0.836768 12.6761C0.645023 9.79988 2.37045 7.14097 5.07528 6.14445L16.8782 1.79601Z"
                        ></path>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import DicePointerImg from '@/assets/imgs/casino/spacedicePointer.png';

const props = defineProps({
    betAmount: {
        type: Number,
        required: true,
    },
    is_in: {
        type: Boolean,
        required: true,
    },
    minModelValue: {
        type: Number,
        required: true,
    },
    maxModelValue: {
        type: Number,
    },
    resultPosition:{
        type: Object,
        requited: true
    }
});

const isGreen = computed(() => {
    if (props.is_in) {
        const isBetAmountInRange =
            props.betAmount >= props.minModelValue && props.betAmount <= props.maxModelValue;
        return isBetAmountInRange;
    } else {
        const isBetAmoutOutRange =
            props.betAmount < props.minModelValue || props.betAmount > props.maxModelValue;
        return isBetAmoutOutRange;
    }
});
</script>
